
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class TemplateService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/templates',query);
    }

    create(body: any) {
        return this.post('/template',body);
    }

    find(id) {
        return this.get('/template/'+id);
    }

    update(id, body) {
        return this.put('/template/'+id, body);
    }

    _delete(id) {
        return this.delete('/template/'+id);
    }

    all(id) {
        return this.get('/user/all-template/'+id);
    }

  chatTemplate() {
      return this.get('/chat/templates')
  }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Template.service.ts